/* eslint-disable @typescript-eslint/no-explicit-any */

import { clearDasherToken, clearTrelloToken } from '@shared/index'
import { type Trello } from '../types/trello'
import { PUP_ID } from '../config'
import { apiClient } from '../api/api'
import { clearAllStoredCardData } from '../storage'

export async function  getRemoveData (
  t: Trello.PowerUp.IFrame,
): Promise<void> {
  await apiClient.revokeQuickbooksAuth(t)
  clearTrelloToken(t, PUP_ID)
  clearDasherToken(t)
  // The badge mirrors QuickBooks customer names into Trello's own card data, and
  // the card back mirrors a "has tracked time" flag alongside it, so removing
  // the power-up has to take both with it.
  await clearAllStoredCardData(t)
}
